import {MITTWALD_API, Schemas} from '../middleware/MittwaldApi'
import * as ActionTypes from '../constants/ActionTypes'
import {agencyServerArticleNumber, cartApiEndpoint} from '../config/Config'
import {getCorrectPhoneFormat, validateSepa as validateSepaValues} from '../util/validate'
import {APP_MODE_ACCESSORY, APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE, DELIMITER_NOTE, INVOICE_TYPE_POST, OUTSOURCING_ADDPROJECT, PAYMENT_TYPE_INVOICE, PAYMENT_TYPE_SEPA, SALUTATION_DEFAULT_VALUE} from '../constants/General'
import {_agencyServer, _contract, getAffiliateId} from "../selectors/GetParam";
import {queryBearerToken} from './UserAuthentication'
import {isMode} from "../selectors/Mode";
import {getInitialCartFormData} from "../selectors/Cart";
import {getBillingTypeSelection, getCart, getCartAllowedForCustomerChange, getCartCommissionValue, getCartId, getContracts, getPostalInvoiceSelection, getResellers, getToggleSelections, isBillingAddressOpened, isContactPersonOpened} from "../selectors/SimpleSelectors";
import {getBillingAddressForm, getCommissionForm, getContactPersonForm, getContractPartnerForm, getOrderNoteForm, getPhoneVerificationForm, getSepaForm, getTestingForm, isNewCustomerSelected} from "../selectors/Forms";
import {getSelectedAccount} from "../selectors/ProductSelection";
import {delve, getCookie} from "../util/util";
import {isExistingUserAuthenticatedAndSelected} from "../selectors/UserInterface";

// **************************************************************************************************************
const fetchPutFormData = (bearer, cartId, formData) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.CART_PUT_FORM_DATA_REQUEST, ActionTypes.CART_PUT_FORM_DATA_SUCCESS, ActionTypes.CART_PUT_FORM_DATA_FAILURE],
        endpoint: `${cartApiEndpoint}/${cartId}`,
        bearer: bearer,
        schema: Schemas.CARTSCHEMA,
        method: 'PUT',
        postData: formData
    }
})
/*let latestFormDataCall = 0*/

/**
 *
 * @param isFinalCall
 * @returns {function(*, *): *}
 */
export const putFormData = (isFinalCall = false) => (dispatch, getState) => {

    // don't spam putFormData
    /*if(new Date().getTime() - latestFormDataCall < 100) {
     return
     }

     latestFormDataCall = new Date().getTime()*/

    let formData = Object.assign(
        {},
        getInitialCartFormData(getState())
    )

    const state = getState()


    const commissionByCookie = getCookie('recommendationCode');

    if (getAffiliateId()) {
        if (!getCartCommissionValue(state)) {
            formData.commission = getAffiliateId()
        } else {
            formData.commission = getCartCommissionValue(state)
        }
    } else if (getCommissionForm(state) && getCommissionForm(state).values) {
        formData.commission = getCommissionForm(state).values.commission
    } else {
        if (getState().cart.isCommissionLocked && getState().cart.commission) {
            formData.commission = getState().cart.commission
        }
    }


    if (isNewCustomerSelected(state)) {

        //if contract partner form is valid
        if (getContractPartnerForm(state) && getContractPartnerForm(state).values && Object.keys(getContractPartnerForm(state).values).length > 0) {

            // if data is valid, push contractPartner data
            if (!getContractPartnerForm(state).syncErrors) {
                formData.contractPartner = Object.assign({}, getContractPartnerForm(state).values)

                if (formData.contractPartner.phone) {
                    formData.contractPartner.phone = getCorrectPhoneFormat(formData.contractPartner.phone)
                }

                if (formData.contractPartner.salutation === 'keine Angabe') {
                    formData.contractPartner.salutation = '';
                }

                Object.keys(formData["contractPartner"]).forEach((key) => {
                    formData["contractPartner"][key] = String(formData["contractPartner"][key]).trim()
                })

            }

            // if data is set, push note
            if (getContractPartnerForm(state).values.note) {
                formData.note = getContractPartnerForm(state).values.note
            } else {
                formData.note = ""
            }

            //phone selected, form exists?
            if (getPhoneVerificationForm(state) && getPhoneVerificationForm(state).values && getPhoneVerificationForm(state).values.note) {
                formData.note = formData.note + DELIMITER_NOTE + getPhoneVerificationForm(state).values.note
            }

            // if data is set, set client type
            if (getContractPartnerForm(state).values.recommendedAccount) {
                formData.recommendedAccount = getContractPartnerForm(state).values.recommendedAccount
            }
        }

        // if billing address is set and valid, push - else delete
        if (getBillingAddressForm(state) && getBillingAddressForm(state).values && Object.keys(getBillingAddressForm(state).values).length > 0) {
            if (isBillingAddressOpened(state) && !getBillingAddressForm(state).syncErrors) {
                formData.billingAddress = Object.assign({}, getBillingAddressForm(state).values)
                if (formData.billingAddress.phone) {
                    formData.billingAddress.phone = getCorrectPhoneFormat(formData.billingAddress.phone)
                }

                if (formData.billingAddress.salutation === 'keine Angabe') {
                    formData.billingAddress.salutation = '';
                }

                Object.keys(formData["billingAddress"]).forEach((key) => {
                    formData["billingAddress"][key] = String(formData["billingAddress"][key]).trim()
                })

            } else {
                // empty data if no longer opened
                delete formData.billingAddress
            }
        }

        // if technical contact is set and valid, push - else delete
        if (getContactPersonForm(state) && getContactPersonForm(state).values && Object.keys(getContactPersonForm(state).values).length > 0) {
            if (isContactPersonOpened(state) && !getContactPersonForm(state).syncErrors) {
                formData.contactPerson = Object.assign({}, getContactPersonForm(state).values)
                if (formData.contactPerson.phone) {
                    formData.contactPerson.phone = getCorrectPhoneFormat(formData.contactPerson.phone)
                }

                if (formData.contactPerson.salutation === 'keine Angabe') {
                    formData.contactPerson.salutation = '';
                }

                Object.keys(formData["contactPerson"]).forEach((key) => {
                    formData["contactPerson"][key] = String(formData["contactPerson"][key]).trim()
                })


            } else {
                // empty data if no longer opened
                delete formData.contactPerson
            }
        }
    }

    // if payment type is selected, push
    if (getBillingTypeSelection(state) !== undefined) {

        if (!formData.paymentSettings) {
            formData.paymentSettings = {}
        }

        if (getBillingTypeSelection(state) === PAYMENT_TYPE_INVOICE) {

            // delete existing sepa data
            if (formData.paymentSettings.iban) {
                delete formData.paymentSettings.iban
            }
            if (formData.paymentSettings.bic) {
                delete formData.paymentSettings.bic
            }
            if (formData.paymentSettings.accountHolder) {
                delete formData.paymentSettings.accountHolder
            }

            formData.paymentSettings.billingType = PAYMENT_TYPE_INVOICE

        } else if (getBillingTypeSelection(state) === PAYMENT_TYPE_SEPA) {

            // delete existing invoice
            if (formData.paymentSettings.billingType) {
                delete formData.paymentSettings.billingType
            }

            // if no validationResult errors, push data
            if (getSepaForm(state) && getSepaForm(state).values && !Object.keys(validateSepaValues(getSepaForm(state).values)).length) {
                const sepaValues = getSepaForm(state).values

                formData.paymentSettings = Object.assign({}, formData.paymentSettings, {
                    billingType: PAYMENT_TYPE_SEPA,
                    bic: String(sepaValues.bic).trim(),
                    iban: String(sepaValues.iban).trim(),
                    accountHolder: String(sepaValues.accountHolder).trim()
                })

            }
        }
    }

    // postal invoice selected?
    if (getPostalInvoiceSelection(state) !== undefined) {
        // postal invoice true?
        if (!formData.paymentSettings) {
            formData.paymentSettings = {}
        }
        formData.paymentSettings.postalInvoice = getPostalInvoiceSelection(state) === INVOICE_TYPE_POST
    }

    if (state.properties.software && state.properties.software !== "default" && state.properties.software !== "") {
        formData.software = state.properties.software
    }

    // promotion code entered and validated?
    if (state.promotionCode.validatedPromotionCode) {
        formData.promotionCode = state.promotionCode.codeInformation.code
    } else {
        formData.promotionCode = ""
    }

    if (state.database.databaseSelected) {
        formData.mysqlVersion = state.database.databaseSelected
    } else if (state.database.defaultOption) {
        formData.mysqlVersion = state.database.defaultOption.uid
    }

    if (!isNewCustomerSelected(state) && getOrderNoteForm(state) && getOrderNoteForm(state).values && getOrderNoteForm(state).values.note) {
        formData.note = getOrderNoteForm(state).values.note
    }

    /** Validate values in properties state and assign values if matching **/
    if ([1, 2, 3, 4].indexOf(state.properties.billingPeriod) >= 0) {
        formData.billingPeriod = state.properties.billingPeriod;
    }
    if ([1, 7, 14, 28].indexOf(state.properties.backupRange) >= 0) {
        formData.backupRange = state.properties.backupRange;
    }
    /** **/
    if (state.properties.projectName) {
        formData.projectName = state.properties.projectName;
    }

    if (state.properties.projectPasswordInCart) {
        formData.projectPassword = state.properties.projectPasswordInCart;
    } else if (state.properties.projectPassword) {
        formData.projectPassword = state.properties.projectPassword;
    }

    if (isMode(APP_MODE_ACCESSORY)) {

        formData.sourceAccount = "" + getSelectedAccount(getState());

    } else if (isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT)) {

        formData.agencyServer = _agencyServer;

    } else if (isMode(APP_MODE_PRODUCT_CHANGE)) {

        const contracts = getContracts(getState());
        const resellers = getResellers(getState());
        const resellerId = delve(contracts, _contract + ".account.reseller.uid");
        const article = delve(contracts, _contract + ".article");

        // don't set sourceAccount on legacy resellers
        if (article.type === "vserver" && parseInt(article.articleNumber, 10) < 70000) {

        } else {
            formData.sourceAccount = "" + getSelectedAccount(getState());
        }

        if (resellerId && (resellers[resellerId].articleNumber + '') === agencyServerArticleNumber) {
            formData.agencyServer = "" + resellerId;
        }

    } else if (isMode(APP_MODE_OUTSOURCING)) {

        const toggleSelections = getToggleSelections(getState())

        if (toggleSelections["outsourcingTarget"] === OUTSOURCING_ADDPROJECT) {
            formData.agencyServer = toggleSelections["outsourcingResellerTarget"]
        }

        formData.sourceAccount = getSelectedAccount(getState());

    } else {

        const currentCartState = getCart(getState());

        if (currentCartState && currentCartState["sourceAccount"]) {
            formData.sourceAccount = currentCartState["sourceAccount"]
        }

        if (currentCartState && currentCartState["agencyServer"]) {
            formData.agencyServer = currentCartState["agencyServer"]
        }

        if (getCartAllowedForCustomerChange(state)) {
            if (delve(state, "properties.commission", null) !== null) {
                formData.commission = state.properties.commission;
            }
        }

    }

    if (isExistingUserAuthenticatedAndSelected(getState())) {
        // only allow testing for new customers
        formData.testing = false
    } else {
        const testingForm = getTestingForm(getState());

        if (testingForm && testingForm.values) {
            if (testingForm.values.testing) {
                formData.testing = testingForm.values.testing
            }
        } else {
            formData.testing = state.cart.testing
        }
    }


    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchPutFormData(state.token.bearer, getCartId(state), formData))
    })

}


/**
 *
 * @param isFinalCall
 * @returns {Function}
 */
export const putSimpleFormData = () => (dispatch, getState) => {


    let formData = Object.assign(
        {},
        getInitialCartFormData(getState())
    )

    const state = getState()

    if (isNewCustomerSelected(state)) {

        //if contract partner form is valid
        if (getContractPartnerForm(state) && getContractPartnerForm(state).values && Object.keys(getContractPartnerForm(state).values).length > 0) {

            // if data is valid, push contractPartner data
            if (!getContractPartnerForm(state).syncErrors) {
                formData.contractPartner = getContractPartnerForm(state).values

                if (formData.contractPartner.phone) {
                    formData.contractPartner.phone = getCorrectPhoneFormat(formData.contractPartner.phone)
                } else {
                    formData.contractPartner.phone = "+49-0000-00000"
                }

                if (formData.contractPartner.salutation === 'keine Angabe') {
                    formData.contractPartner.salutation = '';
                }
            }
        }
    }

    if (state.properties && state.properties.software && state.properties.software !== "default") {
        formData.software = state.properties.software
    }

    if (!formData.paymentSettings) {
        formData.paymentSettings = {}
    }

    formData.paymentSettings.billingType = PAYMENT_TYPE_INVOICE
    formData.paymentSettings.postalInvoice = false

    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchPutFormData(state.token.bearer, getCartId(state), formData))
    })

}



/** WEBPACK FOOTER **
 ** ./src/actions/FormData.js
 **/